function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { BlockForm, BlockInformation, BlockResultTabs, Footer, Header, DisplayMessages } from './components';
import { BlockApi } from './components/BlockApi';
import { extractAndParsePermalink } from './permalink';
import { useFormContext } from './state/form';
import { useSettingsContext } from './state/settings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var PAGE_MAIN = 'main';
var PAGE_INFORMATIONS = 'infos';
var PAGE_API = 'api';
export function AppContent(_ref) {
  var locale = _ref.locale,
      legacyUrl = _ref.legacyUrl,
      HeaderCmp = _ref.headerCmp,
      HelmetCmp = _ref.helmetCmp;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      permalinkData = _useState2[0],
      setPermalinkData = _useState2[1];

  useEffect(function () {
    setPermalinkData(extractAndParsePermalink());
  }, [setPermalinkData]);

  var _useFormContext = useFormContext(),
      form = _useFormContext.state.submittedForm;

  var _useSettingsContext = useSettingsContext(),
      theme = _useSettingsContext.state.data.theme;

  var _useState3 = useState(PAGE_MAIN),
      _useState4 = _slicedToArray(_useState3, 2),
      visiblePage = _useState4[0],
      setVisiblePage = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isTabStats = _useState6[0],
      setTabStats = _useState6[1];

  useEffect(function () {
    if (permalinkData !== null && permalinkData[1]) {
      setTabStats(true);
    }
  }, [permalinkData]);
  var intl = useIntl();

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      focused = _useState8[0],
      setFocused = _useState8[1];

  useEffect(function () {
    return setFocused(false);
  }, []);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(HelmetCmp, {
      children: [/*#__PURE__*/_jsx("title", {
        children: (form !== null ? intl.formatMessage({
          id: 'meta.title_search'
        }, {
          query: [form.surname, form.givenName].map(function (s) {
            return s ? s.trim() : s;
          }).filter(function (s) {
            return s;
          }).join(' ')
        }) + ' · ' : '') + intl.formatMessage({
          id: 'header.title'
        })
      }), /*#__PURE__*/_jsx("body", {
        className: theme
      })]
    }), /*#__PURE__*/_jsx(HeaderCmp, {}), /*#__PURE__*/_jsx(Header, {}), visiblePage === PAGE_MAIN ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(DisplayMessages, {
        legacyUrl: legacyUrl
      }), /*#__PURE__*/_jsx(BlockForm, {
        initialPartialData: permalinkData !== null ? permalinkData[0] : null,
        setInitialPartialData: function setInitialPartialData() {
          return setPermalinkData(null);
        },
        onClear: function onClear() {
          return setTabStats(false);
        },
        focused: focused
      }), /*#__PURE__*/_jsx(BlockResultTabs, {
        isTabStats: isTabStats,
        setTabStats: setTabStats
      })]
    }) : visiblePage === PAGE_INFORMATIONS ? /*#__PURE__*/_jsx(BlockInformation, {
      onBackClick: function onBackClick() {
        return setVisiblePage(PAGE_MAIN);
      }
    }) : visiblePage === PAGE_API ? /*#__PURE__*/_jsx(BlockApi, {
      onBackClick: function onBackClick() {
        return setVisiblePage(PAGE_MAIN);
      }
    }) : null, /*#__PURE__*/_jsx(Footer, {
      onInformationClick: function onInformationClick() {
        return setVisiblePage(PAGE_INFORMATIONS);
      },
      onApiClick: function onApiClick() {
        return setVisiblePage(PAGE_API);
      }
    })]
  });
}
AppContent.propTypes = {
  legacyUrl: PropTypes.string,
  locale: PropTypes.string.isRequired,
  headerCmp: PropTypes.any.isRequired,
  helmetCmp: PropTypes.any.isRequired
};
AppContent.defaultProps = {
  legacyUrl: null
};